/* eslint-disable @typescript-eslint/no-explicit-any -- mirrors the generated LoggingHttpService signature */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_PATH, Configuration, InteractionEventDto, LoggingHttpService } from 'app/api';
import { Observable } from 'rxjs';

const USER_AGENT_PROPERTY_KEY = 'user_agent';

/**
 * Adds device metadata to every interaction event. Kept outside app/api because that
 * folder is regenerated from the OpenAPI spec. Registered as the LoggingHttpService
 * provider in AppModule, so existing call sites need no changes.
 *
 * user_agent is read in the browser, so it is client-supplied and must be treated as
 * untrusted. Lens reading the User-Agent header instead would make it trustworthy and
 * let this class go away.
 *
 * ip_address is not set here: the browser cannot see the real client IP. Stamping it
 * server-side in Lens, which receives these calls directly, is not done yet — see TE-5769.
 */
@Injectable()
export class InteractionLoggingService extends LoggingHttpService {
	constructor() {
		super(inject(HttpClient), inject(BASE_PATH, { optional: true }), inject(Configuration, { optional: true }));
	}

	public override logInteractionEvent(
		interactionEventDto?: InteractionEventDto,
		observe: any = 'body',
		reportProgress = false,
		options?: { httpHeaderAccept?: undefined }
	): Observable<any> {
		return super.logInteractionEvent(this.withUserAgent(interactionEventDto), observe, reportProgress, options);
	}

	private withUserAgent(interactionEventDto?: InteractionEventDto): InteractionEventDto | undefined {
		const userAgent = this.getUserAgent();
		if (!interactionEventDto || !userAgent) return interactionEventDto;

		const properties = interactionEventDto.properties || [];
		if (properties.some(property => property?.key === USER_AGENT_PROPERTY_KEY)) return interactionEventDto;

		return {
			...interactionEventDto,
			properties: [...properties, { key: USER_AGENT_PROPERTY_KEY, value: userAgent }],
		};
	}

	private getUserAgent(): string | undefined {
		try {
			return typeof navigator === 'undefined' ? undefined : navigator.userAgent || undefined;
		} catch {
			return undefined;
		}
	}
}
